const getRunnerUrl = (parentUrl) => {
	if (parentUrl.includes('localhost:3000')) {
		return 'http://localhost:5012/api/v1';
	}

	if (parentUrl.includes('staging-') || parentUrl.includes('myreviewlogin')) {
		return 'https://staging-runner.chekkit.io/api/v1';
	}

	return 'https://runner.chekkit.io/api/v1';
};

export default getRunnerUrl;
